import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Label from '../common/Label';

class CallDetailInput extends PureComponent {
  render() {
    const {
      Input,
      value,
      inputKey,
      labelText,
      isDisabled,
      optionData,
      eventHandler,
      additionalProps,
      isErrorTriggered,
      customErrorMessage,
      isRequired = true,
    } = this.props;

    let errorMessage = customErrorMessage || `${labelText} is required.`;
    const validationRules = {
      required: isRequired,
    };

    if (inputKey === 'dateOfCall') {
      validationRules.regex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(20)\d{2}$/;
      errorMessage += ` mm/dd/yyyy format`
    }

    // This component doesn't care what type of input it's being passed
    return (
      <div className="ac-call-detail-input">
        <Label text={labelText} />
        <Input
          hideXDelete
          value={value}
          inputKey={inputKey}
          {...additionalProps}
          isDisabled={isDisabled}
          optionData={optionData}
          placeholder="- Select -"
          eventHandler={eventHandler}
          errorMessage={errorMessage}
          isErrorTriggered={isErrorTriggered}
          outerWrapClassNames="ac-call-detail-input__input-wrap ac-question-input__input"
          validationRules={validationRules}
        />
      </div>
    );
  }
}

CallDetailInput.propTypes = {
  optionData: PropTypes.array,
  Input: PropTypes.any.isRequired,
  additionalProps: PropTypes.object,
  value: PropTypes.any.isRequired,
  customErrorMessage: PropTypes.string,
  inputKey: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isRequired: PropTypes.bool,
  labelText: PropTypes.string.isRequired,
  eventHandler: PropTypes.func.isRequired,
  isErrorTriggered: PropTypes.bool.isRequired,
};

CallDetailInput.defaultProps = {
  optionData: [],
  additionalProps: {},
  customErrorMessage: null,
};

export default CallDetailInput;



// WEBPACK FOOTER //
// ./src/features/agent-coaching/CallDetailInput.js